import { PageAudienceFilter, usePageFilterContext } from '@/components/page';
import PendoPlaceholder from '@/components/PendoPlaceholder/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

const VendorOverviewActions = () => {
  const {
    pageFilters: { audience },
  } = usePageFilterContext();

  return (
    <div className="flex items-center gap-2">
      <PendoPlaceholder />
      <PageAudienceFilter />
      <ShareMenu
        notificationPageKey="vendors"
        notificationParams={{
          audienceIds: audience?.id,
        }}
      />
    </div>
  );
};

export default VendorOverviewActions;
